/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateHtmlPageConfigEnableReqVo
 */
export interface UpdateHtmlPageConfigEnableReqVo {
    /**
     * 操作 1可用 0不可用
     * @type {number}
     * @memberof UpdateHtmlPageConfigEnableReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the UpdateHtmlPageConfigEnableReqVo interface.
 */
export function instanceOfUpdateHtmlPageConfigEnableReqVo(value: object): value is UpdateHtmlPageConfigEnableReqVo {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UpdateHtmlPageConfigEnableReqVoFromJSON(json: any): UpdateHtmlPageConfigEnableReqVo {
    return UpdateHtmlPageConfigEnableReqVoFromJSONTyped(json, false);
}

export function UpdateHtmlPageConfigEnableReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHtmlPageConfigEnableReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function UpdateHtmlPageConfigEnableReqVoToJSON(json: any): UpdateHtmlPageConfigEnableReqVo {
    return UpdateHtmlPageConfigEnableReqVoToJSONTyped(json, false);
}

export function UpdateHtmlPageConfigEnableReqVoToJSONTyped(value?: UpdateHtmlPageConfigEnableReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
    };
}

